export const API_URL = process.env.REACT_APP_API_URL || "";

export const ML_API_URL = "http://qc-ml.h7bxfphrayd9hphy.westus2.azurecontainer.io:8080"